/* eslint-disable @typescript-eslint/no-namespace */
import { CellFormats } from '../../types/cell.types';

export namespace DataExport {
  export interface ExportCell {
    value: any;
    format?: string;
    colSpan?: number;
  }

  export abstract class ExportColumnDefinition {
    headerName: string;
    valueProvider: ExportDataValueProvider;
    formatProvider?: ExportFormatProvider;

    optional: boolean;
    protected mappers: ((value: any) => any)[];
    conditionToInclude?: (data: any) => boolean;

    constructor(options?: {
      formatProvider?: ExportFormatProvider;
      conditionToInclude?: (data: any) => boolean;
      mappers?: ((value: any) => any)[];
    }) {
      if (options && options.formatProvider) {
        this.formatProvider = options.formatProvider;
      }

      if (options && options.conditionToInclude) {
        this.conditionToInclude = options.conditionToInclude;
        this.optional = true;
      } else {
        this.optional = false;
      }

      if (options && options.mappers) {
        this.mappers = options.mappers;
      } else {
        this.mappers = [];
      }
    }

    applyMappers(value: any): undefined | null | number | string {
      const result = this.mappers.reduce(
        (acc: unknown, mapper: (arg) => unknown) => mapper(acc),
        value
      );

      return result;
    }
  }

  export interface ExportFormatProvider {
    getFormat(value: any): string;
  }

  export interface ExportDataValueProvider {
    getValue(data: any): any;
  }

  export class StaticFormatProvider implements ExportFormatProvider {
    constructor(public format: string) {}
    getFormat(value: any): string {
      return this.format;
    }
  }

  export class NumberWithPrecisionFormatProvider
    implements ExportFormatProvider {
    constructor(public decimalPlaces: number) {}
    getFormat(value: any): string {
      return (0).toFixed(this.decimalPlaces);
    }
  }

  export const sizeFormatProvider: ExportFormatProvider = {
    getFormat(value: any): string {
      if (value == null || Number.isInteger(value as number)) {
        return CellFormats.CurrencyInteger;
      } else {
        return CellFormats.CurrencyDecimal;
      }
    }
  };
}
